var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode == 'IWAK' || _vm.mode == 'STRESS')?_c('PXCreateSurveyAutomaticPage',{attrs:{"mode":_vm.mode}}):_vm._e(),(_vm.mode == 'MANUAL')?_c('PXCreateSurveyManualPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }